export default __webpack_public_path__ + "static/media/streaks 200.26bf9c97.svg";